export const genTextValidation = (val) => {
  return val.length > 1;
}

export const emailValidation = (val) => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(val).toLowerCase());
}

export const telValidation = (val) => {
  const re = /^[0-9]{7,16}$/;
  return re.test(val);
}

export const capValidation = (val) => {
  const re = /^[0-9]{5}$/;
  return re.test(val);
}


export const cfValidation = (val) => {
  const re = /^(?:(?:[B-DF-HJ-NP-TV-Z]|[AEIOU])[AEIOU][AEIOUX]|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}[\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[1256LMRS][\dLMNP-V])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM])(?:[A-MZ][1-9MNP-V][\dLMNP-V]{2}|[A-M][0L](?:[1-9MNP-V][\dLMNP-V]|[0L][1-9MNP-V]))[A-Z]$/i;
  return re.test(String(val).toLowerCase());
}

export const impSValidation = (val) => {
  const re = /^[0-9]{5}$/i;
  return val && re.test(String(val).toLowerCase());
}

export const impYValidation = (val) => {
  const re = /^[0-9]{10}$/i;
  return val && re.test(String(val).toLowerCase());
}

export const impYValidationEl = (val) => {
  const re = /^[0-9]{4}[a-zA-Z]{1}[0-9]{10}$/i;
  return val && re.test(String(val).toLowerCase());
}